module.exports = __webpack_public_path__ + "static/media/icon_print.7942dbc5.svg";